import {useState, useEffect} from 'react'
import Cookies from "js-cookie"
import "./Quest.css"

const Quest = () => {
    const [quest, setQuest] = useState({
        name: "",
        phone: "",
        email: "",
    })


    useEffect(() => {
        const savedQuest = Cookies.get("questData")
        if (savedQuest) {
            setQuest(JSON.parse(savedQuest))
        }
    }, [])

    const handleChange = (e) => {
        const {name, value} = e.target

        setQuest((prev) => ({
            ...prev,
            [name]: value,
        }))
    }

    const handleSubmit = (e) => {
        e.preventDefault()
        try {
            Cookies.set("questData", JSON.stringify(quest), {expires: 7})
            setTimeout(() => {
                window.location.reload()
            }, 500)
        } catch (err) {
            console.log(err)
        } 
    }

  return (
    <div>
        <div className='quest-container'>
            <h2 className="login-title">Pokračovat jako Host</h2>
            <form className="login-form" onSubmit={handleSubmit}>
                <input 
                    type='text'
                    name='name'
                    id='quest-name'
                    value={quest.name}
                    onChange={handleChange}
                    className="login-input"
                    placeholder='Jméno a Přijmení'
                />
                <input 
                    type="email"
                    name="email"
                    id='quest-email'
                    placeholder="Email"
                    value={quest.email}
                    onChange={handleChange}
                    className="login-input"
                />
                <input
                    type="text"
                    name="phone"
                    id='quest-phone'
                    placeholder="Telefon"
                    value={quest.phone}
                    onChange={handleChange}
                    className="login-input"
                />
                <button type='submit' className="login-button">Potvrdit</button>
            </form>
        </div>
    </div>
  )
}

export default Quest